import _ from 'lodash'
import appWidgetDefinition from './appWidgetDefinition.json'
import classicOverrides from './classicOverrides.json'

export const classicAppWidgetStructure = _.assign({}, appWidgetDefinition, classicOverrides)
